module.exports = __webpack_public_path__ + "static/media/Sedan.e526da3b.svg";